import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepReadingLevel from "components/Step/StepReadingLevel";
import { Subscription } from "lib/api/subscription";

export const MembershipStepReadingLevel = ({
  routePrevStep,
  ...state
}: MembershipState) => {
  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepReadingLevel
      {...state}
      initialValues={state.readingLevelValues}
      stepFooterProps={{ backButtonProps }}
      stepHeaderProps={{ backButtonProps }}
      subscription={state.subscription as Subscription}
    />
  );
};

export const MEMBERSHIP_STEP_READING_LEVEL: MembershipStep = {
  component: MembershipStepReadingLevel,
  id: "membership-id-reading-level",
  slug: "reading-level",
};

export default MEMBERSHIP_STEP_READING_LEVEL;
